export const datasetType ={
    FETCH_DOWNLOAD_URL_REQUEST:"FETCH_DOWNLOAD_URL_REQUEST",
    FETCH_DOWNLOAD_URL_SUCCESS:"FETCH_DOWNLOAD_URL_SUCCESS",
    FETCH_DOWNLOAD_URL_FAILURE:"FETCH_DOWNLOAD_URL_FAILURE",

    FETCH_DATASETS_REQUEST:"FETCH_DATASETS_REQUEST",
    FETCH_DATASETS_SUCCESS:"FETCH_DATASETS_SUCCESS",
    FETCH_DATASETS_FAILURE:"FETCH_DATASETS_FAILURE",

    CLEAN_DATASET_ELEMENTS:"CLEAN_DATASET_ELEMENTS",
    CLEAN_DATASETS:"CLEAN_DATASETS",

    ADD_DATASET_ROUTE:"ADD_DATASET_ROUTE",
    UPDATE_DATASET_ROUTE:"UPDATE_DATASET_ROUTE",
    CLEAN_DATASET_ROUTE:"CLEAN_DATASET_ROUTE"


} 